<template>
  <!--subscribe start-->
  <section class="subscribe-bg" ref="subscribePosition">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-lg-4">
          <div class="subscribe">
            <h3>Subscribe to Newsletter</h3>
          </div>
        </div>
        <div class="col-sm-12 col-lg-8">
          <div class="email-box">
            <form
              action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda"
              class="auth-form needs-validation"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              target="_blank"
            >
              <input
                class="form-control"
                name="EMAIL"
                id="mce-EMAIL"
                placeholder="Your email address:"
                type="email"
                required="required"
              />
              <button type="submit" class="btn btn-email" id="mc-submit">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--subscribe end -->
</template>
<script>
export default {
  name: "Subscribe",
  mounted() {
    let payload = {
      position: this.$refs["subscribePosition"].offsetTop,
      name: "subscribePosition",
    };
    this.$emit("windowPosition", payload);
  },
};
</script>
